<template>
  <MoreOptionsMenuButton
    v-bind="attrs"
    v-if="
      currentUser?.hasPermission('clients.change_client') ||
      currentUser?.hasPermission('clients.delete_client')
    "
  >
    <v-list-item
      v-if="currentUser.hasPermission('clients.change_client')"
      @click="emit('client-edit-pressed', client)"
      title="Edit Client"
    >
      <template #prepend>
        <v-icon size="18" icon="mdi-pencil" class="me-1" />
      </template>
    </v-list-item>

    <template v-if="currentUser.hasPermission('clients.delete_client')">
      <v-divider class="pb-1" v-if="currentUser.hasPermission('clients.change_client')" />
      <v-list-item
        class="text-error"
        @click="emit('client-delete-pressed', client)"
        title="Delete Client"
      >
        <template #prepend>
          <v-icon size="18" icon="mdi-delete" class="me-1" />
        </template>
      </v-list-item>
    </template>
  </MoreOptionsMenuButton>
</template>

<script setup lang="ts">
import { useAttrs } from 'vue'
import { storeToRefs } from 'pinia'

import type { IClient } from '@/models/client'

import { useAuthStore } from '@/stores'

import MoreOptionsMenuButton from '../common/MoreOptionsMenuButton.vue'

interface Props {
  client: IClient
}
defineProps<Props>()

interface Emit {
  (e: 'client-edit-pressed', client: IClient): void
  (e: 'client-delete-pressed', client: IClient): void
}
const emit = defineEmits<Emit>()

const attrs = useAttrs()

const authStore = useAuthStore()
const { getUser: currentUser } = storeToRefs(authStore)
</script>
